import type { ComponentType, SVGProps } from 'react';
import { Building, CubeBandage, DatabaseStar, LightBulbOn, Message, Presentation, Tools } from 'iconoir-react';
import { cn } from 'lib/utils';
import { SkillIcon } from 'components/core/skill-icon';
import type { ConfigureNavIconConfig } from 'constant/configure-nav';
import { CreateAgentIcon } from './icons/create-agent-icon';

const CONFIGURE_ICON_MAP = {
  CreateAgent: CreateAgentIcon,
  Skill: SkillIcon,
  CubeBandage,
  LightBulbOn,
  DatabaseStar,
  Tools,
  Presentation,
  Message,
  Building,
} satisfies Record<Extract<ConfigureNavIconConfig, { type: 'iconoir' }>['name'], ComponentType<SVGProps<SVGSVGElement>>>;

interface ConfigureNavIconProps {
  icon: ConfigureNavIconConfig;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

export function ConfigureNavIcon({
  icon,
  size = 20,
  strokeWidth = 1.75,
  className,
}: ConfigureNavIconProps) {
  const IconComponent = CONFIGURE_ICON_MAP[icon.name];

  return (
    <IconComponent
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={cn('shrink-0', className)}
      aria-hidden
    />
  );
}
